import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { withTranslation } from "react-i18next";
import { Table } from "semantic-ui-react";

const UiMeet3dEventDetailsFirstMove = observer(({ data, t }) => {
  return (
    <Table definition>
      <Table.Body>
        <Table.Row>
          <Table.Cell width={4}>{t("clientPanelMisc:name")}</Table.Cell>
          <Table.Cell>{data.user.name}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell width={4}>{t("clientPanelMisc:location")}</Table.Cell>
          <Table.Cell>
            {data.user.location.city ? data.user.location.city : t("clientPanelMisc:locationUnknown")}
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  );
});

UiMeet3dEventDetailsFirstMove.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
};

export default withTranslation()(UiMeet3dEventDetailsFirstMove);
